import { render } from "./SelectStone.vue?vue&type=template&id=012b2932"
import script from "./SelectStone.vue?vue&type=script&lang=js"
export * from "./SelectStone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__